module.exports = __webpack_public_path__ + "static/media/product1.3d05f41b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Home/product1.png
// module id = 526
// module chunks = 0